export default __webpack_public_path__ + "static/media/Aneomi.97c3bd56.png";